  <div #dropCards class="drop-cards">
    <div class="zoom-container">
      <mat-card class="input-card" dndDraggable [dndDraggable]="{ type: 'INPUT_TEXT' }" dndEffectAllowed="copyMove"
                (click)="onAddNewComponent('INPUT_TEXT')" matTooltip="{{ 'INPUT TEXT' | translate }}">
        <mat-card-content class="">
          <img src="../../../../../../assets/icons/text-cursor-white.svg" width="24" height="24" draggable="false">
        </mat-card-content>
      </mat-card>

      <mat-card class="input-card" dndDraggable [dndDraggable]="{ type: 'TEXT_AREA' }" dndEffectAllowed="copyMove"
                (click)="onAddNewComponent('TEXT_AREA')" matTooltip="{{ 'TEXT_AREA' | translate }}">
        <mat-card-content class="">
          <mat-icon>text_format</mat-icon>
        </mat-card-content>
      </mat-card>

      <mat-card class="input-card" dndDraggable [dndDraggable]="{ type: 'NUMBER' }" dndEffectAllowed="copyMove"
                (click)="onAddNewComponent('NUMBER')" matTooltip="{{ 'NUMBER' | translate }}">
        <mat-card-content class="">
          <mat-icon>looks_one</mat-icon>
        </mat-card-content>
      </mat-card>

      <mat-card class="input-card" dndDraggable [dndDraggable]="{ type: 'DATE' }" dndEffectAllowed="copyMove"
                (click)="onAddNewComponent('DATE')" matTooltip="{{ 'DATE' | translate }}">
        <mat-card-content class="">
          <mat-icon>date_range</mat-icon>
        </mat-card-content>
      </mat-card>

      <mat-card class="input-card" dndDraggable [dndDraggable]="{ type: 'COLOR' }" dndEffectAllowed="copyMove"
                (click)="onAddNewComponent('COLOR')" matTooltip="{{ 'COLOR' | translate }}">
        <mat-card-content class="">
          <mat-icon>color_lens</mat-icon>
        </mat-card-content>
      </mat-card>

      <mat-card class="input-card" dndDraggable [dndDraggable]="{ type: 'FILE' }" dndEffectAllowed="copyMove"
                (click)="onAddNewComponent('FILE')" matTooltip="{{ 'FILE' | translate }}">
        <mat-card-content class="">
          <mat-icon>attach_file</mat-icon>
        </mat-card-content>
      </mat-card>


      <mat-card #selectCard class="input-card" (mouseenter)="onEnterMenu('SELECTS')" (mouseleave)="onLeaveMenu()" matTooltip="{{ 'SELECT' | translate }}" matTooltipPosition="right">
        <mat-icon>format_list_bulleted</mat-icon>
      </mat-card>

      <mat-card class="input-card" dndDraggable [dndDraggable]="{ type: 'CHECKBOX' }" dndEffectAllowed="copyMove"
                (click)="onAddNewComponent('CHECKBOX')" matTooltip="{{ 'CHOICE_BUTTON' | translate }}">
        <mat-card-content class="">
          <mat-icon>check_box</mat-icon>
        </mat-card-content>
      </mat-card>

      <mat-card class="input-card" dndDraggable [dndDraggable]="{ type: 'BUTTON' }" dndEffectAllowed="copyMove"
                (click)="onAddNewComponent('BUTTON')" matTooltip="{{ 'BUTTON' | translate }}">
        <mat-card-content class="">
          <mat-icon>insert_link</mat-icon>
        </mat-card-content>
      </mat-card>

      <mat-card class="input-card" dndDraggable [dndDraggable]="{ type: 'TEXT' }" dndEffectAllowed="copyMove"
                (click)="onAddNewComponent('TEXT')" matTooltip="{{ 'TEXT' | translate }}">
        <mat-card-content class="">
          <mat-icon>text_fields</mat-icon>
        </mat-card-content>
      </mat-card>

      <mat-card class="input-card" dndDraggable [dndDraggable]="{ type: 'TITLE' }" dndEffectAllowed="copyMove"
                (click)="onAddNewComponent('TITLE')" matTooltip="{{ 'TITLE' | translate }}">
        <mat-card-content class="">
          <mat-icon>title</mat-icon>
        </mat-card-content>
      </mat-card>

      <mat-card class="input-card" dndDraggable [dndDraggable]="{ type: 'HTML' }" dndEffectAllowed="copyMove"
                (click)="onAddNewComponent('HTML')" matTooltip="Html">
        <mat-card-content class="">
          <mat-icon>code</mat-icon>
        </mat-card-content>
      </mat-card>

      <div class="vertical-separator"></div>

      <mat-card #businessCard class="input-card menu" (mouseenter)="onEnterMenu('BUSINESS')" (mouseleave)="onLeaveMenu()" matTooltip="{{ 'BUSINESS' | translate }}" matTooltipPosition="right">
        <mat-icon>business</mat-icon>
      </mat-card>
    </div>
  </div>

  <div #dropdownMenu
      *ngIf="activeMenu"
      class="dropdown-list drop-cards"
      [ngStyle]="activeMenu === 'BUSINESS' ? dropdownStyles : dropdownStylesSelects"
      (mouseenter)="onEnterMenu(activeMenu)"
      (mouseleave)="onLeaveMenu()">

    <div class="zoom-container m-0 gap-1 flex-column">

      <mat-card *ngFor="let item of activeMenuItems"
                class="input-card"
                dndDraggable
                [dndDraggable]="{ type: item.type }"
                (click)="onAddNewComponent(item.type)"
                [matTooltip]="item.label | translate"
                matTooltipPosition="right">
        <mat-card-content>
          <mat-icon>{{ item.icon }}</mat-icon>
        </mat-card-content>
      </mat-card>

    </div>
  </div>

  <div #blockContainer class="container blockUnselected cdc-block" [ngClass]="{'blockSelected': selectedBlock && activeRightSideBar === 'blockSettings'}" (click)="buildSideBarSettings()">
    <div #slideTitle class="slideTitle d-flex flex-row">
      <span #blockTitle class="slideTitle" tooltipTruncate [matTooltip]="block.title!">{{block.title}}</span>
    </div>
    <div #slideContent class="slideContent slideContent-editor" cdkDropList #groupsList="cdkDropList" [cdkDropListData]="block.componentGroups"
         (cdkDropListDropped)="dropGroup($event)">
         <!-- dndDropzone (dndDrop)="dropOnBlock($event)"> -->
      <div *ngFor="let componentsGroup of block.componentGroups; let i = index;" cdkDrag>

        <!-- dropzone before -->
        <div class="dropzone"
             dndDropzone
             (dndDrop)="dropBetweenGroups($event, i)"
             (dragenter)="onDragEnter($event, i)"
             (dragleave)="onDragLeave($event, i)"
             (dragover)="onDragOver($event)"
             [ngClass]="{'dropzone-active': activeDropIndex === i}">
          <div class="drop-indicator"></div>
        </div>

        <div class="m-2 groupHover"
             [ngClass]="{'groupSelected': selectedGroupId === componentsGroup.id && hoveredGroupId !== componentsGroup.id, 'groupDashed': hoveredGroupId === componentsGroup.id}"
             (click)="onSelectGroup($event, componentsGroup)"
             dndDropzone
             [dndDragoverClass]="'drag-over-group'"
             (dndDrop)="dropOnGroup($event, componentsGroup.id)">

          <div class="flex-row justify-content-between groupHeader">
            <div class="d-flex flex-row">
              <mat-icon class="icon"
                        matTooltip="{{'Multiple answers' | translate}}"
                        *ngIf="componentsGroup.multipleConfig?.maxQuantity === null || componentsGroup.multipleConfig?.maxQuantity === undefined || componentsGroup.multipleConfig?.maxQuantity! > 1"
                        [ngClass]="{'iconVisible': selectedGroupId === componentsGroup.id}">
                view_list
              </mat-icon>
            </div>

            <div>
              <mat-icon class="icon-g drag-icon" [ngClass]="{'iconVisible': selectedGroupId === componentsGroup.id}" cdkDragHandle matTooltip="{{'Drag' | translate}}">drag_indicator</mat-icon>
            </div>
          </div>

          <app-group-config #groupComponent [componentsGroup]="componentsGroup" [selectedComponentId]="selectedComponentId"
                            class="group-config"
                            (componentSelected)="onSelectComponent($event.componentId, $event.groupId, $event.open)"
                            (reorderComponents)="afterReorderComponents()">
          </app-group-config>

          <a *ngIf="canAddGroup(componentsGroup)"
             class="add-group"
             (mouseenter)="onMouseEnter(componentsGroup.id)"
             (mouseleave)="onMouseLeave(componentsGroup.id)">
            <mat-icon>add_circle</mat-icon> {{componentsGroup.multipleConfig!.textBtnMultiple}}
          </a>
        </div>
      </div>

      <div
          class="dropzone"
          dndDropzone
          (dndDrop)="dropBetweenGroups($event)"
          (dragenter)="onDragEnter($event, -1)"
          (dragleave)="onDragLeave($event, -1)"
          (dragover)="onDragOver($event)"
          [ngClass]="{'dropzone-active': activeDropIndex === -1}">
        <div class="drop-indicator"></div>
      </div>
    </div>
  </div>


